const scrap_terms = (
  <>
    <h1>Scrap - Terms & Conditions - Read word for word</h1>
    <p>
      Your vehicle is being collected by a company called (collector name). They
      will call you from an area code (First 3 digits of collector number) so
      look out for that number calling you, you&apos;ll also receive a text with
      their details. They will schedule the pickup with you directly
    </p>
    <p>
      They will arrange the payment with you by (insert payment method) which is
      $XXX based on the vehicle being complete (other than the items mentioned)
      and general condition described, not fire damaged
    </p>
    <p>
      Please have the (Title / registration / insurance card / bill of sale) and
      some photo ID ready for when the driver arrives
    </p>
    <p>
      Please make sure the vehicle is cleared out of any trash and personal
      items
    </p>
    <p>
      Do you have any questions for me at all? (Answer any questions in full)
    </p>
  </>
);

export { scrap_terms };
